export default __webpack_public_path__ + "static/media/dryingroom.1e6e250c.svg";